import { useAppContextFeatures } from "../context/AppContext"

export const _operatorSymbols = {
    eq: "=",
    startsWith: "_%",
    endsWith: "%_",
    contains: "%",
    containsOr: "%||",
    anyOf: "where_in",
    anyOfOr: "or_where_in",
    excludeOf: "where_not_in",
    excludeOfOr: "or_where_not_in",
    moreThanEq: ">=",
    moreThanEqOr: ">=||",
    lessThanEq: "<=",
    lessThanEqOr: "<=||",
    notEq: "!=",
    eqOr: "=||",
    havingInOr: "or_having_in",
    isNull: "null",
    isNotNull: "null!=",
    isNullOr: "null||"
}

export const _operatorDef = {
    eq: "eq",
    startsWith: "startsWith",
    endsWith: "endsWith",
    contains: "contains",
    containsOr: "containsOr",
    anyOf: "anyOf",
    anyOfOr: "anyOfOr",
    excludeOf: "excludeOf",
    excludeOfOr: "excludeOfOr",
    moreThanEq: "moreThanEq",
    moreThanEqOr: "moreThanEqOr",
    lessThanEq: "lessThanEq",
    lessThanEqOr: "lessThanEqOr",
    notEq: "notEq",
    eqOr: "eqOr",
    havingInOr: "havingInOr",
    isNull: "isNull",
    isNotNull: "isNotNull",
    isNullOr: "isNullOr"
}

export function useServerParams() {

    const { getLocationIds } = useAppContextFeatures();

    const getOperatorSymbol = (type) => {
        return _operatorSymbols[type]
    }

    const getListsUrl = (endpoint, props) => {

        let filters;

        const limit = props?.limit;
        const offset = props?.skip;
        const filterValue = props?.filterValue;
        const sortInfo = props?.sortInfo;
        const dataTypes = props?.dataTypes ? props.dataTypes : [];

        const customFilterLocationEnable = props?.customFilterLocationEnable;
        const customFilterLocationFields = props?.customFilterLocationFields
        // const filterLocationIds = props?.filterLocationIds

        if (filters === undefined) filters = [];

        if (filterValue) {
            for (let i = 0; i < filterValue.length; i += 1) {
                if (filterValue[i]?.value ||
                    filterValue[i].operator === _operatorDef.isNull ||
                    filterValue[i].operator === _operatorDef.isNotNull ||
                    filterValue[i].operator === _operatorDef.isNullOr
                ) {

                    let line = {
                        "field": filterValue[i]?.name,
                        "operator": getOperatorSymbol(filterValue[i].operator),
                        "value": filterValue[i]?.value
                    }

                    if (filterValue[i]?.group) {
                        line.group = filterValue[i].group
                    }

                    filters.push(line)
                }
            }
        }

        // check the custom filters enabled for this query
        if (customFilterLocationEnable && customFilterLocationFields) {

            // console.log('getLo', getLocationIds())

            const v = getLocationIds();
            const ids = [];

            // console.log('v >>> ', v)

            if (v.length <= 0) {
                throw new Error(`At least (1) location must be selected`)
            }

            // console.log('v', v)
            if (v.length) {
                for (let i = 0; i < v.length; i += 1) {
                    ids.push(v[i])
                }
            }

            if (ids.length) {

                customFilterLocationFields.forEach(fieldName => {
                    filters.push({
                        field: fieldName,
                        operator: _operatorSymbols.anyOfOr,
                        value: JSON.stringify(ids),
                        group: "name_group"
                    })
                })

            }

        }

        let sortfield = props?.defaultSortField ? props?.defaultSortField : 'id';
        let sortorder = props?.defaultSortOrder ? props?.defaultSortOrder : 'desc';

        if (sortInfo?.id) {
            sortfield = sortInfo?.id;
            sortorder = sortInfo?.dir === -1 ? 'desc' : 'asc'
        }

        let url = `${endpoint}?limit=${limit}&offset=${offset}&sortfield=${sortfield}&sortorder=${sortorder}`;

        if (filters && filters.length > 0)
            url += `&filters=${JSON.stringify(filters)}`;
        else
            url += `&filters=[]`

        if (dataTypes.length)
            url += `&datatypes=${JSON.stringify(dataTypes)}`

        // console.log('url', url)

        return url;

    }

    const getUrlWithDataTypes = (endpoint, dataTypesArray = []) => {
        return `${endpoint}?datatypes=${JSON.stringify(dataTypesArray)}`
    }

    return { _operatorDef, getListsUrl, getUrlWithDataTypes, getOperatorSymbol }
}